




















































import { Component, Vue } from "vue-property-decorator";
import AppFooter from "@/components/AppFooter.vue";
import QrCodeImg from "@/components/QrCodeImg.vue";
import * as util from "@/util";
import { domain, ActivationQRData } from "@/domain";
import { packQRData } from "@/uiUtil";

@Component({
  components: { AppFooter, QrCodeImg }
})
export default class TerminalQRConfig extends Vue {
  error = false;
  qrData = "";
  qrLoading = true;
  parsedData: ActivationQRData = {
    branchID: 0,
    terminalID: 0,
    tcod: "",
    language: this.langKey
  };

  created() {
    if (this.$route.query.data) {
      const queryData = this.$route.query.data as string;
      this.parseData(queryData).catch((ex) => {
        util.logError("TerminalQRConfig: Error parsing query = " + queryData, ex);
        this.error = true;
      });
    } else {
      util.logError("TerminalQRConfig: QR Data is empty");
      this.error = true;
    }
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get langKey() {
    return this.$store.state.lang.key as string;
  }

  async parseData(data: string) {
    this.qrLoading = true;
    this.error = false;
    let qrObj = JSON.parse(util.fromBase64Url(data)) as ActivationQRData;
    this.parsedData = qrObj;
    qrObj = await domain.backend.getTerminalQR(qrObj);
    this.parsedData = qrObj;
    this.qrData = packQRData(qrObj);
    this.qrLoading = false;
  }
}
